import { IonPage, IonToast } from '@ionic/react';
import { ThunkDispatch } from '@reduxjs/toolkit';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { RootState } from '../App';
import { QuirkIonContent } from '../components/QuirkIonContent';
import { useLoading } from '../hooks/useQuirkLoading';
import { NotificationState, emailUnsubscribe } from '../state/notificationsSlice';

export function Unsubscribe(): JSX.Element {
	const { token } = useParams<{ token: string }>();
	const state: NotificationState = useSelector<RootState, NotificationState>(state => state.notification);
	useLoading({
		isLoading: state.email === 'unsubscribing' || state.email === null,
		message: 'Please wait...'
	});
	const history = useHistory();
	const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

	const onDismiss = () => {
		history.push('/main/latest');
	};

	useEffect(() => {
		if (token) {
			dispatch(emailUnsubscribe({ token }));
		}
	}, [dispatch, token]);

	return (
		<IonPage>
			<QuirkIonContent flush>
				<>
					<IonToast
						isOpen={state.email === 'unsubscribed'}
						duration={1500}
						message="Successfully Unsubscribed"
						position="top"
						onDidDismiss={onDismiss}
					/>
					<IonToast
						isOpen={state.email === 'error'}
						duration={1500}
						message="There was an error unsubscribing"
						color="danger"
						position="top"
						onDidDismiss={onDismiss}
					/>
				</>
			</QuirkIonContent>
		</IonPage>
	);
}
